import { TASK_STATUSES } from './constants';

// eslint-disable-next-line import/prefer-default-export
export function isTaskOngoing(status) {
  return [
    TASK_STATUSES.PENDING,
    TASK_STATUSES.STARTED,
    TASK_STATUSES.RETRY,
    TASK_STATUSES.RECEIVED,
  ].includes(status);
}
